import { withInstall } from '@vuemap/vue-amap-util'
import WMS from './WMS.vue'

export const ElAmapLayerWms = withInstall(WMS)
export default ElAmapLayerWms
